import type {TableConfiguration} from 'schema/table/types';
import type {AgentCorporation} from 'services/agent/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';
import {corporationAgentDefaultColumns} from './columns';

export const corporationAgentTableConfig: TableConfiguration<AgentCorporation> =
  {
    ...defaultTableConfig,
    defaultColumns: corporationAgentDefaultColumns,
  };
